/*
const myPath = new RectangleTextPath({
  x: 50,
  y: 50,
  fill: 'black',
  fontSize: 24,
  fontFamily: 'Arial',
  text: 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
  rectangleWidth: 400,
  rectangleHeight: 200,
  rectangleRadius: 20,
});
//console.log("myPath", myPath);
layer.add(myPath);
layer.draw();
*/
class RectangleTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'RectangleTextPath';

    this.rectangleWidth(config?.rectangleWidth ?? 400);
    this.rectangleHeight(config?.setRectangleHeight ?? 200);
    this.rectangleRadius(config?.rectangleRadius ?? 20);
  }


  static getAttrNames() { return ['amplitude', 'frequency', 'waves']; }
  static getDefaultAttrs() { return { amplitude: 80, frequency: 120, waves: 2 }; }


  rectangleWidth(v) {
    if (v === undefined) return this.attrs.rectangleWidth ?? 0;
    this.attrs.rectangleWidth = v;
    this.updatePath();
    return this;
  }


  rectangleHeight(v) {
    if (v === undefined) return this.attrs.rectangleHeight ?? 0;
    this.attrs.rectangleHeight = v;
    this.updatePath();
    return this;
  }


  rectangleRadius(v) {
    if (v === undefined) return this.attrs.rectangleRadius ?? 0;
    this.attrs.rectangleRadius = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath(200, 200, this.rectangleWidth(), this.rectangleHeight(), this.rectangleRadius()));
  }


  generateSvgPath(x, y, width, height, rx = 0, ry = 0) {
    // If rx or ry are not specified, or if they are 0, create a standard rectangle path.
    if (rx === 0 && ry === 0) {
      return `M${x},${y} H${x + width} V${y + height} H${x} V${x},${y} Z`;
    }

    // Handle rounded corners
    // If only one of rx or ry is provided, assume the other is the same.
    if (rx === 0) rx = ry;
    if (ry === 0) ry = rx;

    // Ensure rx and ry do not exceed half the width/height respectively
    rx = Math.min(rx, width / 2);
    ry = Math.min(ry, height / 2);

    return `M${x + rx},${y} ` + // Move to top-left corner, after the arc
          `H${x + width - rx} ` + // Line to top-right corner, before the arc
          `A${rx},${ry} 0 0 1 ${x + width},${y + ry} ` + // Arc to top-right corner

          `V${y + height - ry} ` + // Line to bottom-right corner, before the arc
          `A${rx},${ry} 0 0 1 ${x + width - rx},${y + height} ` + // Arc to bottom-right corner
          `H${x + rx} ` + // Line to bottom-left corner, before the arc
          `A${rx},${ry} 0 0 1 ${x},${y + height - ry} ` + // Arc to bottom-left corner
          `V${y + ry} ` + // Line to top-left corner, before the arc
          `A${rx},${ry} 0 0 1 ${x + rx},${y} ` + // Arc to top-left corner
          `Z`; // Close the path
  }
}
